import { readCookie, setCookie } from '../utils/cookie_manager'

document.addEventListener('DOMContentLoaded', () => {
    setCookie("cachestatus", "MISS", -1);
    setTimeout(() => {                
        if (readCookie('cache_flag')){
            setCookie("cache_flag", false, -1)
            setCookie("cachestatus", "MISS", 7);
        }else{
            setCookie("cachestatus", "HIT", 7);
        }
    }, 100);
});
